import { Link } from "react-router-dom";
import { getCategories, getSitesByCategory } from "@/lib/navData";
import { gradientAt } from "@/lib/tone";

export default function CategoryGrid() {
  const categories = getCategories();

  return (
    <div className="flex md:grid md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 overflow-x-auto md:overflow-visible pb-2 md:pb-0 -mx-4 px-4 md:mx-0 md:px-0">
      {categories.map((cat, i) => (
        <Link
          key={cat.id}
          to={`/category/${encodeURIComponent(cat.id)}`}
          className="group min-w-[160px] md:min-w-0 flex items-center gap-3 p-3.5 rounded-xl border border-background-200 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <span
            className={`w-11 h-11 rounded-lg bg-gradient-to-br ${gradientAt(i)} text-background-50 flex items-center justify-center shrink-0`}
          >
            <i className={`${cat.icon} text-xl`} />
          </span>
          <span className="min-w-0">
            <span className="block font-heading font-semibold text-sm text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
              {cat.name}
            </span>
            <span className="block text-xs text-foreground-400 mt-0.5">
              收录 {getSitesByCategory(cat.id).length} 个
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}